import { decodePeriodValue, encodePeriodValue, GlobalPeriodSelect } from '@components'

import { Flex, Space } from '@billy/design-system'
import React, { useCallback, useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { PeriodValue } from '../../../../../../../types/periodValue'
import { ExpandButton } from '../../../../../elements/ExpandButton'
import { PeriodsComparisonDropdown } from '../../../../../elements/PeriodsComparisonDropdown'
import { ViewSettings } from '../../../../../elements/ViewSettings'
import { SettingsAction } from '../../../../../enums/settingsAction'
import { PeriodComparisonValue } from '../../../../../types/periodComparisonValue'
import { periodModeToComparisonValue } from '../../../../../utils/periodModeToComparisonValue'
import { useProfitAndLossFilters } from '../../contexts/profitAndLossFiltersContext'

export const ProfitAndLossActions = () => {
  const { organization } = useUserOrganization()
  const { appliedFilters, setQueryParams } = useProfitAndLossFilters()

  const handlePeriodChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organization?.id) {
        return
      }
      const periodValueEncoded = periodValue ? encodePeriodValue(periodValue, organization.id) : undefined
      const mode: PeriodComparisonValue = periodModeToComparisonValue(periodValue.mode)

      setQueryParams({ compareWith: mode, period: periodValueEncoded })
    },
    [organization?.id, setQueryParams],
  )

  const handleComparisonPeriodSelect = useCallback(
    (_id: string, value: number) => {
      setQueryParams({ compareCount: value.toString() })
    },
    [setQueryParams],
  )

  const periodDecoded = useMemo(
    () => (appliedFilters.period ? decodePeriodValue(appliedFilters.period) : undefined),
    [appliedFilters.period],
  )

  return (
    <Flex justifyContent="space-between">
      <GlobalPeriodSelect encodedPeriod={appliedFilters.period} onChange={handlePeriodChange} />
      <Space horizontal size="s8" />
      <PeriodsComparisonDropdown
        key={appliedFilters.compareCount?.toString()}
        mode={appliedFilters.compareWith}
        onSelect={handleComparisonPeriodSelect}
        selectedId={appliedFilters.compareCount?.toString()}
        period={periodDecoded}
      />
      <ExpandButton />
      <Space horizontal size="s8" />
      <ViewSettings
        appliedFilters={appliedFilters}
        setQueryParams={setQueryParams}
        availableSettings={[SettingsAction.HideZeros, SettingsAction.ShowChange, SettingsAction.ShowGroupPercentage]}
      />
    </Flex>
  )
}
